import React from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";

import SubmenuButton from "../components/SubmenuButton";

import { sendNavigationMetric } from "../../../utils/sendMetric";

import { useStore } from "../../../connect";

import {
  MAIN_PAGE_QUERY_PARAM_STRING,
  MAIN_PAGE_QUERY_PARAM,
} from "../../../consts";

import strings from "../../../locales/strings";

const AddTruckLink = ({ isTablet, color, isFullWidth }) => {
  const { profile, baseUrl, header } = useStore();

  const handleClick = () => {
    profile.onLoginOpen({
      next: `https://trucks.${baseUrl}/published?utm_source=header&utm_campaign=new_header`,
      additionalQueryParams: header.isMainPage ? MAIN_PAGE_QUERY_PARAM : "",
    });
  };

  return profile.isLoggedIn ? (
    <SubmenuButton
      href={`https://trucks.${baseUrl}/trucks/create?utm_source=header&utm_campaign=new_header${
        header.isMainPage ? `&${MAIN_PAGE_QUERY_PARAM_STRING}` : ""
      }`}
      icon="ic_add-out"
      dataName="add-truck-link"
      popupName="addTruck"
      newTab
      color={color}
      isFullWidth={isFullWidth}
      onClick={() => sendNavigationMetric("SUB_MENU_ADD_TRUCK")}
    >
      {isTablet ? strings.truck : strings.addTruck}
    </SubmenuButton>
  ) : (
    <SubmenuButton
      icon="ic_add-out"
      onClick={handleClick}
      dataName="add-truck-link"
      color={color}
      isFullWidth={isFullWidth}
    >
      {isTablet ? strings.truck : strings.addTruck}
    </SubmenuButton>
  );
};

AddTruckLink.propTypes = {
  isTablet: PropTypes.bool,
  color: PropTypes.oneOf(["green", "yellow", "gray"]),
  isFullWidth: PropTypes.bool,
};

export default observer(AddTruckLink);
